<template>
	<div class="headNav mainContent">
		<img @click="getActive('Inicio')" class="logo" src="@/assets/image/logo.png" alt="" />
		<div class="nav">
			<button :class="activeNav == 'home' ? 'active' : ''">
				<a @click="getActive('home')">Inicio</a>
			</button>
			<button :class="activeNav == 'sobre' ? 'active' : ''">
				<a @click="getActive('sobre')">Sobre nosotros</a>
			</button>
			<button :class="activeNav == 'FAQ' ? 'active' : ''">
				<a @click="getActive('FAQ')">FAQ</a>
			</button>
			<button :class="activeNav == 'Aviso' ? 'active' : ''">
				<a @click="getActive('Aviso')">Aviso de privacidad</a>
			</button>
			<button :class="activeNav == 'complaints' ? 'active' : ''">
				<a @click="getActive('complaints')">Quejas y Sugerencias</a>
			</button>
			<!-- <li :class="activeNav== 'loan'? 'active' : ''"><a @click="getActive('loan')">Términos y condiciones</a></li> -->
		</div>

		<!-- <div class="broadcast-content-bg">
			<div class="broadcast-content">
				<div class="content-wrapper">
					<span class="content">
						Debido a problemas en la red, la APP no está disponible temporalmente para su descarga. Prevemos que el
						servicio se restablezca en un plazo de 24 horas. Lamentamos las molestias ocasionadas.
					</span>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import './scss/nav.scss'

	export default {
		name: 'headNav',
		props: ['activeNav'],
		data() {
			return {
				// active: "Inicio",
			}
		},
		created() {
			console.log(this.activeNav)
			// this.active = this.activeNav;
			// console.log(nav, this.active);
			// if (nav) {
			//   this.active = nav;
			// } else {
			//   localStorage.setItem('activeNav', "Inicio");
			// }
		},
		methods: {
			getActive(val) {
				let url = ''
				switch (val) {
					case 'home':
						url = '/home'
						break
					case 'sobre':
						url = '/about'
						break
					case 'Aviso':
						url = '/notice'
						break
					case 'FAQ':
						url = '/help'
						break
					case 'loan':
						url = '/loan'
						break
					case 'complaints':
						url = '/complaints'
						break
				}
				this.$router.push(url)
			},
		},
	}
</script>

<style></style>
